import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constant";
 import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";
import Jobs from "./pages/Jobs";


 const DashboardPage = lazy(() => import("@feature/pages/UserDashboard"));
 const MyShowsPage = lazy(() => import("@feature/pages/MyShows"));
 const ExhibitorDashboardPage = lazy(() => import("@feature/pages/ExhibitorDashboard"));
 const CallbackPage = lazy(() => import("@feature/pages/Callback"));

@injectable()
@registry([{ token: FeatureToken, useClass: UserDashboard }])
class UserDashboard implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "User Dashboard",
                path: featurePaths.Dashboard,
                page: DashboardPage
            },
            {
                title: "Jobs",
                path: featurePaths.Jobs,
                page: Jobs
            }
            ,
            {
                title: "My Shows",
                path: featurePaths.MyShows,
                page: MyShowsPage
            },
            {
                title: "Exhibitor Dashboard",
                path: featurePaths.ExhibitorDashboard,
                page: ExhibitorDashboardPage
            },
            {
                title: "Callback",
                path: featurePaths.Callback,
                page: CallbackPage
            }
        ]
    };
}
